import { MDSTextColor, MDSTextWeight } from "@/mds";
import { useEffectOnMount } from "@/domains/react/useEffectOnMount";
import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { FC, useCallback } from "react";
import { useLocation } from "react-router";
import { windowModule } from "@/modules/window";
import { MDSText, MDSTextVariant } from "@/mds";
import { MDSLoadingIcon, MDSLoadingIconSize } from "@/mds/components/loading-icon";

export const GoogleOAuthRedirectDesktopPage: FC = observer(() => {
  const location = useLocation();

  const navigateToTargetUrl = useCallback(() => {
    const targetUrlPath = `mem://google-oauth-redirect${location.search}`;
    const targetUrl = new URL(targetUrlPath);

    windowModule.navigateToExternal({
      url: targetUrl,
    });
  }, [location.search]);

  useEffectOnMount(() => {
    navigateToTargetUrl();
  });

  return (
    <Wrapper>
      <MDSLoadingIcon size={MDSLoadingIconSize.Large} />
      <LoadingMessage
        variant={MDSTextVariant.HeaderM}
        weight={MDSTextWeight.Regular}
        color={MDSTextColor.Contrast}
      >
        Opening Mem...
      </LoadingMessage>
      <MDSText
        variant={MDSTextVariant.TextS}
        weight={MDSTextWeight.Regular}
        color={MDSTextColor.Secondary}
      >
        Click to <StyledLink onClick={navigateToTargetUrl}>open</StyledLink> if nothing happens
      </MDSText>
    </Wrapper>
  );
});

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex-wrap: nowrap;
  background-color: ${({ theme }) => theme.colors.surface.chrome};
`;

const LoadingMessage = styled(MDSText)`
  margin-top: ${({ theme }) => theme.spacing[4]};
  margin-bottom: ${({ theme }) => theme.spacing[2]};
`;

const StyledLink = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;
